/** A crop window applied to a measurement's raw data before charting.
 *  null on either bound means "no limit on that side". Absent / both-null = full range. */
export interface MeasurementWindow {
  startTs: string | Date | null;
  endTs: string | Date | null;
}

/** One removed datapoint. Doubles as the removal audit record — never pruned.
 *  Matched to a raw datapoint by timestamp equality (+ channelKey for multi-channel types). */
export interface RemovedPoint {
  ts: string | Date;          // the datapoint's timestamp
  channelKey?: string;        // e.g. 'channel3' for SHM; absent for single-vector types
  reason?: string;            // optional free text from the confirm dialog
  removedAt: string | Date;
  removedBy: string;          // user _id
}

/** True when `rp` refers to the raw datapoint at `entryTs` (optionally in `channelKey`). */
export function removedPointMatches(rp: RemovedPoint, entryTs: Date, channelKey?: string): boolean {
  const rpChannel = rp.channelKey ?? undefined;
  if (rpChannel !== (channelKey ?? undefined)) return false;
  return new Date(rp.ts).getTime() === entryTs.getTime();
}
